/**
 * RoomsController — /api/v1/rooms
 * Mirrors: src/Aidepo.Api/Controllers/RoomsController.cs
 */
import { apiDelete, apiPatch, apiPost } from '../client.js';
import type { Uuid } from '../types.js';

export interface CreateRoomRequest {
  readonly name: string;
  readonly propertyId?: Uuid;
  readonly propertyNameHint?: string;
  /**
   * Manually picked icon name (hh-345). Omit or pass null to auto-resolve
   * the icon from the room name.
   */
  readonly icon?: string | null;
}

export interface UpdateRoomRequest {
  readonly name?: string;
  /**
   * Icon override (hh-345). Field absent → not changed; non-empty string →
   * manual icon set; `null` → reset to auto-resolve.
   */
  readonly icon?: string | null;
}

export interface RoomCreatedResponse {
  readonly id: Uuid;
  readonly name: string;
  readonly propertyId: Uuid;
  readonly propertyName: string;
  /** Resolved icon name, or null when left to auto-resolve (hh-345). */
  readonly icon?: string | null;
}

export interface RoomUpdatedResponse {
  readonly id: Uuid;
  readonly name: string;
  readonly propertyId: Uuid;
  /** Resolved icon name, or null when left to auto-resolve (hh-345). */
  readonly icon?: string | null;
}

/** POST /api/v1/rooms — create a room inside a property. */
export function createRoom(req: CreateRoomRequest): Promise<RoomCreatedResponse> {
  return apiPost<RoomCreatedResponse, CreateRoomRequest>('/api/v1/rooms', req);
}

/** PATCH /api/v1/rooms/{id} — rename. */
export function updateRoom(id: Uuid, req: UpdateRoomRequest): Promise<RoomUpdatedResponse> {
  return apiPatch<RoomUpdatedResponse, UpdateRoomRequest>(`/api/v1/rooms/${id}`, req);
}

/** DELETE /api/v1/rooms/{id} — items/equipment re-attach to the parent property. */
export function deleteRoom(id: Uuid): Promise<void> {
  return apiDelete(`/api/v1/rooms/${id}`);
}
